import React, { useEffect, useRef } from 'react';
import { useInfiniteHits } from 'react-instantsearch-hooks-web';

export default function InfiniteHitsArt({ hitComponent: HitComponent, ...props }) {
    const { hits, isLastPage, showMore } = useInfiniteHits(props);
    const sentinelRef = useRef(null);

    useEffect(() => {
        if (sentinelRef.current !== null) {
            const observer = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting && !isLastPage) {
                        showMore();
                    }
                });
            });

            observer.observe(sentinelRef.current);

            return () => {
                observer.disconnect();
            };
        }
    }, [isLastPage, showMore]);

    return (
        <div className="ais-InfiniteHits">
            <ul className="ais-InfiniteHits-list">
                {hits.map((hit) => (
                    <li key={hit.ID} style={{padding: '1rem'}}>
                        <HitComponent hit={hit} />
                    </li>
                ))}
                <li
                    className="ais-InfiniteHits-sentinel"
                    ref={sentinelRef}
                    aria-hidden="true"
                />
            </ul>
        </div>
    );
}
